<template>
  <div class="OpenidForm">
    <!-- <a-card> -->
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="微信openid" prop="openId">
        <a-input v-model="form.openId" placeholder="请输入" />
      </a-form-model-item>

      <a-form-model-item label="分组" prop="type">
        <a-select v-model="form.type" placeholder="请选择" :defaultActiveFirstOption="false">
          <a-select-option :value="1">销售</a-select-option>
          <a-select-option :value="2">生产</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 14, offset: 2 }">
        <a-button type="primary" @click="onSubmit" :loading="loading">提交</a-button>
      </a-form-model-item>
    </a-form-model>
    <!-- </a-card> -->
  </div>
</template>

<script>
import { addOpenid, modifyOpenid, getOpenid } from '@/api/api'

const rules = {
  openId: [
    {
      required: true,
      message: '请输入',
      trigger: 'blur'
    },
    {
      max: 32,
      message: '最大32个字符',
      trigger: 'blur'
    }
  ],
  type: [
    {
      required: true,
      message: '请选择',
      trigger: 'change'
    }
  ]
}

export default {
  name: 'OpenidForm',

  props: ['operate'],

  data() {
    return {
      labelCol: { span: 2 },
      wrapperCol: { span: 6 },
      form: {
        openId: undefined,
        type: undefined
      },
      rules,
      loading: false
    }
  },

  created() {
    if (this.operate === 'modify') {
      this.getOpenid(this.$route.params.openId)
    }
  },

  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true

          if (this.operate === 'add') {
            addOpenid(this.form)
              .then(res => {
                if (res.error.code === 0) {
                  this.$message.success('添加成功')
                  this.form = {
                    openId: undefined,
                    type: undefined
                  }
                }
              })
              .finally(() => {
                setTimeout(() => {
                  this.loading = false
                }, 500)
              })
          } else if (this.operate === 'modify') {
            modifyOpenid(this.form)
              .then(res => {
                if (res.error.code === 0) {
                  this.$message.success('修改成功')
                }
              })
              .finally(() => {
                setTimeout(() => {
                  this.loading = false
                }, 500)
              })
          }
        }
      })
    },

    getOpenid(openid) {
      getOpenid(openid).then(res => {
        if (res.error.code === 0) {
          this.form = { ...res.response }
        }
      })
    }
  }
}
</script>


<style lang="less" scoped>
.OpenidForm {
  background-color: white;
  padding: 24px;
  padding-top: 32px;
}
</style>
